module.exports = __webpack_public_path__ + "static/media/playstore-6c.cfac6f56.png";